import queryString from "query-string";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { Loader } from "../../components";
import Form from "./create audience components/Form";
import {
  audienceObject,
  objectFromResponse,
} from "./create audience components/audienceObjects";
import { useAxios, useComponent } from "../../hooks";

export default function AudienceDetails() {
  const axios = useAxios();
  const params = useParams();
  const { loader } = useComponent();

  const audienceID = params.audienceID || "";
  const mode = queryString.parse(window.location.search).mode;

  const [fields, setFields] = useState([]);
  const [categories, setCategories] = useState();
  const [editState, setEditState] = useState(true);
  const [formData, setFormData] = useState(audienceObject);

  useEffect(() => {
    if (!mode) {
      setEditState(false);
    }
    if (!!audienceID) {
      setEditState(false);
    }

    if (mode === "edit") {
      setEditState(true);
    }

    loader.start(3);

    axios({
      url: "/fields/fieldsGroups",
    }).then((response) => {
      if (response.status) {
        let category = [];
        for (let [index, cat] of response.data?.entries()) {
          category.push(cat[index + 1]);
        }
        setCategories(category);
        loader.apiComplete();
      }
    });

    axios({
      url: "/adtech/getAllDynamicFields",
      method: "GET",
      disableRedirect: true,
    })
      .then((response) => {
        if (response.status) {
          var fields = response.data;
          setFields(response.data);

          if (!!audienceID) {
            axios({
              url: "/brand/getDetailsOfAudience/" + audienceID,
              method: "GET",
            }).then((responses) => {
              if (responses.status) {
                let data = objectFromResponse(responses.data, fields);
                setFormData(data);
                loader.apiComplete();
                loader.apiComplete();
              }
            });
          } else {
            let data = {
              ...audienceObject,
            };

            loader.stop();
            setFormData(data);
          }
        }
      })
      .catch((err) => console.error(err));
  }, [axios, audienceID, mode, loader]);

  return (
    <Loader>
      <Form
        setFields={setFields}
        categories={categories}
        fields={fields}
        formData={formData}
        editState={editState}
        setEditState={setEditState}
      />
    </Loader>
  );
}
